module.exports = __webpack_public_path__ + "static/media/mobile.2e4ff2a2.png";